
import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { DatePipe } from '@angular/common';
import { TagModule } from 'primeng/tag';
import { SelectModule } from 'primeng/select';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { TableComponent } from '../components/table/table.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { environment } from '../../environments/environment';
import { MyMonitoringService } from '../../services/logging.service';
import { DialogModule } from 'primeng/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { DropdownComponent } from '../components/dropdown/dropdown.component';
import { AllRecordsService } from '../../services/allRecordsService';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { DataUtils } from '../utils/DataUtils';
import { Observable, of, switchMap } from 'rxjs';
import { DatePickerModule } from 'primeng/datepicker';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { AdminService } from '../../services/adminService';
import { ApiService } from '../../services/apiservice';
import { DatepickerComponent } from '../components/datepicker/datepicker.component';
import { AutoCompleteComponent } from '../components/autocomplete/autocomplete.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

@Component({
  selector: 'app-call-by-submitter',
  standalone: true,
  templateUrl: './call-by-submitter.component.html',
  styleUrl: './call-by-submitter.component.scss',
  imports: [DialogModule, FloatLabelModule, DatepickerComponent, TableModule, ToastModule, DatePickerModule, TagModule, SelectModule, ButtonModule, InputTextModule, FormsModule, TableComponent, DropdownComponent, ProgressSpinnerModule, SelectModule, AutoCompleteModule, ConfirmPopupModule],
  providers: [MessageService, AllRecordsService, DatePipe, ConfirmationService,
    AutoCompleteComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CallBySubmitterComponent {

  @ViewChild('tblConfig') tblConfig!: TableComponent;

  router: any;
  param: any;
  processMessage: string = "";
  lsNorthDataColumns: any[] = [];
  criticalLoadDataCommentColumns: any[] = [];
  selectedItems: any[] = [];
  AppKeyValuePairs: any[] = [];
  actionButtons: any = [];
  isLoading: boolean = false;
  pageSize: number = 10;
  dialogVisible: boolean = false;
  cellValue: any[] = ['', ''];
  commentTable: any[] = [];
  comments$!: Observable<any[]>;
  selectedRow: any;
  txtComment: any;
  user: any;
  employeeOptions: SelectItem[] = [];
  districtOptions: SelectItem[] = [];
  schuduledDateOptions: SelectItem[] = [];
  dispatchViewOptions: SelectItem[] = [];
  typeOptions: SelectItem[] = [];
  districtsMainCollection: any;
  selectedDistrict: any;
  selectedEmployee: string | undefined;
  selectedScheduledDate: string = "";
  selectedDispatchView: string = "";
  selectedType: any;
  allDistrictData: any[] = [];
  queryData: any = {};
  suggestions!: any[];
  totalRecords: number = 0;
  pageNumber: number = 1;
  sortField: string = "SchedDate";
  sortOrder: number = 0;
  searchText: any = "";
  filteredData$!: Observable<any[]>;


  constructor(
    private route: ActivatedRoute,
    private allRecordsService: AllRecordsService,
    private messageService: MessageService,
    private redirectRoute: Router,
    private monotoringService: MyMonitoringService, private datePipe: DatePipe,
    private confirmationService: ConfirmationService, private apiService: ApiService,
    private adminService: AdminService
  ) {
    this.router = route;
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      this.param = params.get('tier');
      this.tblConfig.searchValue = this.param;
    });

    const temp = JSON.parse(sessionStorage.getItem("queryData")!);

    this.queryData = temp;

    if (temp) {
      this.selectedDistrict = temp.data.DistrictNm;
      this.selectedEmployee = temp.data.Employee;
      this.selectedScheduledDate = temp.data.Sched_Date;
      this.selectedType = temp.data.Type;
      this.getSelectedDistrictDetails();
      sessionStorage.removeItem("queryData")
    }
    this.LoadHeader();
    this.LoadDistrictDetails();
  }

  showDialog() {
    this.dialogVisible = true;
  }


  LoadHeader(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.lsNorthDataColumns = [
      { "field": "Employee", "header": "EMPLOYEE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Type", "header": "TYPE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "District", "header": "DISTRICT", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "SchedDate", "header": "SCHED DATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "State", "header": "STATE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "City", "header": "CITY", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "House", "header": "HOUSE", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Street", "header": "STREET", "filter": true, "isSorting": true, "width": "10%" },
      { "field": "Update", "header": "ACTION", "filter": false, "isSorting": false, "width": "10%", type: "action", isClickable: 'true', onclick: this.handleClick.bind(this) }
    ];
    this.commentTable = [
      { "field": "message", "header": "USER COMMENTS", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdUser", "header": "CREATE BY", "filter": true, "isSorting": true, "isEditable": true, "width": "5%" },
      { "field": "createdDate", "header": "CREATE DATETIME", "filter": true, "isSorting": true, "width": "5%" },
    ]
  }



  uniqueData(data: any) {
    const uniqueData = data.filter((value: any, index: any, self: any) =>
      index === self.findIndex((t: any) => (
        t.label === value.label && t.value === value.value
      ))
    );

    const sortedData = uniqueData.sort((a: any, b: any) => {
      if (a.label < b.label) {
        return -1;
      }
      if (a.label > b.label) {
        return 1;
      }
      return 0;
    });

    return sortedData;
  }

  handleClick(rowData: any): void {
    this.redirectRoute.navigate(['/order-entry', rowData.CCR_ID]);
    const temp = {
      data: {
        DistrictNm: this.selectedDistrict,
        Sched_Date: this.selectedScheduledDate,
        Employee: this.selectedEmployee,
        Type: this.selectedType

      },
      from: "/bysubmitter"
    }
    sessionStorage.setItem("queryData", JSON.stringify(temp));
  }
  LoadDistrictDetails(): void {
    this.isLoading = true;
    this.processMessage = environment.appMessages.loadingMesage;

    this.apiService.groupId().pipe(
      switchMap(groupId => this.allRecordsService.getDistricts(groupId))
    ).subscribe({
      next: (data: any) => {
        this.isLoading = false;
        this.typeOptions = this.uniqueData(data?.Payload.OrderTypeData.map((district: any) => ({
          label: district.Value.trim(),
          value: district.Value
        })));

        this.districtOptions = this.uniqueData(data?.Payload.DistrictData?.map((district: any) => ({
          label: district.District.trim(),
          value: district.District
        })));

        this.districtsMainCollection = data?.Payload;
        this.isLoading = false;
        if (this.queryData) {
          this.queryData = undefined;
        }
      },
      error: error => {
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallBySubmitterComponent.LoadDistrictDetails', message: error }, SeverityLevel.Error);
        this.isLoading = false;
      },
      complete: () => { this.isLoading = false; }
    });
  }

  updateDropdownValuesFromLoad() {
    const tempDistrictsData = this.districtsMainCollection?.filter((item: any) => item.Employee?.trim() === this.selectedEmployee?.trim() && item.Type?.trim() === this.selectedType?.trim());
    const tempScheduledData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.Employee?.trim() === this.selectedEmployee?.trim() && item.Type?.trim() === this.selectedType?.trim());
    const sortedScheduledData = this.uniqueData(tempScheduledData.map((district: any) => ({
      label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
      value: district.SchedDate?.trim()?.toString()
    })));
    this.schuduledDateOptions = DataUtils.filterDuplicates(sortedScheduledData)?.reverse();
  }


  updateDropdownValues() {
    if (this.selectedEmployee !== "" && this.selectedType !== "" && this.selectedDistrict !== "" && this.selectedScheduledDate === "") {
      const tempData = this.districtsMainCollection?.filter((item: any) => item.District?.trim() === this.selectedDistrict?.trim() && item.Employee?.trim() === this.selectedEmployee?.trim() && item.Type?.trim() === this.selectedType?.trim());

      const sortedScheduledData = this.uniqueData(tempData.map((district: any) => ({
        label: this.datePipe.transform(new Date(district.SchedDate.trim()), "MM-dd-yyyy")?.toString(),
        value: district.SchedDate?.trim()?.toString()
      })));
      this.schuduledDateOptions = DataUtils.filterDuplicates(sortedScheduledData)?.reverse();
    }

  }

  getSelectedDistrictDetails(): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;

    this.apiService.groupId().pipe(
      switchMap(groupId => {
        const payload = {
          DistrictNm: this.selectedDistrict === "" ? null : this.selectedDistrict,
          Sched_Date: this.selectedScheduledDate === "" ? null : this.selectedScheduledDate,
          Employee: this.selectedEmployee === "" ? null : this.selectedEmployee,
          Type: this.selectedType === "" ? null : this.selectedType,
          UserID: sessionStorage.getItem('userId'),
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          SortField: this.sortField,
          SortOrder: this.sortOrder,
          SearchText: this.searchText,
          groupId: groupId
        };
        return this.allRecordsService.getRecordDetails(payload);
      })
    ).subscribe({
      next: (data: any) => {
        const updatedData = data?.Payload.Data?.map((item: any) => {
          return {
            ...item,
            SchedDate: this.datePipe.transform(new Date(item.SchedDate.trim()), "MM-dd-yyyy")?.toString()
          }
        });
        this.filteredData$ = of(updatedData);
        this.isLoading = false
        this.totalRecords = data?.Payload?.TotalRecords;
        if (data?.Payload?.Data?.length === 0) {
          const errMsg = environment.appMessages.noData
          this.messageService.add({ severity: 'warn', summary: 'No Data', detail: errMsg, life: environment.appSettings.snakbarLife });
        }
      },
      error: error => {
        this.isLoading = false;
        const errMsg = environment.appMessages.ServerError + error;
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: errMsg });
        this.monotoringService.logException({ name: 'CallBySubmitterComponent.getSelectedDistrictDetails', message: error }, SeverityLevel.Error);
      },
      complete: () => {
        this.isLoading = false;

      }
    });
     
    
  }

  onCellClicked(event: any[]) {
    this.isLoading = true;
    this.cellValue = event;
    this.selectedRow = event[1];
  }


  onCancelCommentClicked() {
    this.txtComment = "";
    this.dialogVisible = false;
  }

  onSaveCommentClicked() {
    this.isLoading = true;
    const cmt = { bqUniqueId: this.selectedRow.bqUniqueId, message: this.txtComment, createdUser: this.user, createdDate: Date() };
    if (cmt === null || cmt === undefined) {
      this.messageService.add({ severity: 'warning', summary: 'warning', detail: environment.appMessages.noChangesFound, life: environment.appSettings.snakbarLife });
      return;
    }
    this.processMessage = environment.appMessages.savinggMesage;
    this.isLoading = false;
  }

  reload() {
    this.tblConfig.clear();
    this.selectedItems = [];
    this.LoadHeader();
  }

  onReloadClicked() {
    this.reload();
  }

  onEmployeeChange(event: any) {
    this.selectedEmployee = event;
    this.selectedScheduledDate = '';
    this.selectedDistrict = '';
    this.selectedType = '';
    this.updateDropdownValues();
  }

  search(event: any) {
    try {

      this.apiService.groupId().pipe(
        switchMap(groupId => {
          return this.adminService.getOrderBySubmitter(event.query || this.selectedEmployee, groupId);
        })
      ).subscribe({
        next: (data: any) => {
          var arr = Array.from((data))
          this.suggestions = Array.from(new Set(arr));
        },
        error: (error) => {
          console.error('Error fetching data:', error);
          this.showError("Failed to fetch order data. please try again later.");
        }
      })
    } catch (e) {
      this.showError("Failed to fetch order data. please try again later.");
    }
  }

  showError(error: string) {
    this.messageService.add({ severity: 'warn', summary: 'Error', detail: error, life: 5000 });
  }

  onEmployeeNameSelect(event: any) {
    this.selectedEmployee = event['value'];
  }


  onScheduledDateChange(event: any) {
    this.selectedScheduledDate = event;
  }

  onDistrictChange(event: any) {
    this.selectedDistrict = event;
  }

  handlePageChange(event: any): void {
    this.pageNumber = event.page;
    this.pageSize = event.pageSize;
    this.getSelectedDistrictDetails();
  }

  getSearchDisabledStatus() {
    return this.selectedDistrict === "" || this.selectedScheduledDate === "" || this.selectedEmployee === "" || this.selectedType === ""
  }

  onTypeChange(event: any) {
    this.selectedType = event;
  }

  onSearch(): void {
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.getSelectedDistrictDetails();
  }

  onClear(): void {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to proceed?',
      icon: 'pi pi-question',
      acceptButtonStyleClass: 'custom-accept-button',
      rejectButtonStyleClass: 'custom-reject-button',
      accept: () => {
        this.selectedScheduledDate = "";
        this.selectedType = "";
        this.selectedDispatchView = "";
        this.selectedScheduledDate = "";
        this.selectedDistrict = "";
        this.selectedEmployee = "";
        this.selectedType = "";
        this.sortField = "";
        this.sortOrder = 1;
        this.searchText = "";
        this.filteredData$ = of([]);
        this.totalRecords = 0
      },
    });
  }
  onSearchText(event: any): void {
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.pageNumber = 1
    this.tblConfig.resetPage();
    this.searchText = event.searchText;
    this.getSelectedDistrictDetails();
  }

  onSortClicked(event: any): void {
    this.sortField = event.sortField;
    this.sortOrder = event.sortOrder;
    this.processMessage = environment.appMessages.loadingMesage;
    this.isLoading = true;
    this.getSelectedDistrictDetails();
  }

}






